
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_1v268_93",
  "grid": "awsui_grid_vj6p7_1v268_128",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_1v268_133",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_1v268_136",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_1v268_143",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_1v268_146",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_1v268_146",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_1v268_149",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_1v268_152",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_1v268_158",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_1v268_164",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_1v268_177",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_1v268_210",
  "root": "awsui_root_vj6p7_1v268_264",
  "tile-container": "awsui_tile-container_vj6p7_1v268_302",
  "refresh": "awsui_refresh_vj6p7_1v268_312",
  "has-metadata": "awsui_has-metadata_vj6p7_1v268_315",
  "selected": "awsui_selected_vj6p7_1v268_321",
  "disabled": "awsui_disabled_vj6p7_1v268_325",
  "columns": "awsui_columns_vj6p7_1v268_340",
  "column-1": "awsui_column-1_vj6p7_1v268_345",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_1v268_352",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_1v268_357",
  "column-2": "awsui_column-2_vj6p7_1v268_362",
  "column-3": "awsui_column-3_vj6p7_1v268_379",
  "column-4": "awsui_column-4_vj6p7_1v268_396",
  "control": "awsui_control_vj6p7_1v268_414",
  "no-image": "awsui_no-image_vj6p7_1v268_418",
  "image": "awsui_image_vj6p7_1v268_422"
};
  